<template>
  <div v-if="showPageContent">
    <v-card-title class="pa-0">
      <v-row no-gutters>
        <v-col class="col-auto mr-3">
          <h2 class="headline font-weight-bold black--text">
            {{ $t("hfManagement.machineryPerformance.machineryList") }}
          </h2>
        </v-col>
        <v-col v-if="hasWritePerm" class="col-auto">
          <v-btn
            color="primary"
            class="caption font-weight-bold"
            outlined
            rounded
            small
            @click="openNewMachineryDialog"
            >{{ $t("add.default") }}</v-btn
          >
        </v-col>
        <v-col class="col-auto ml-auto">
          <v-btn
            color="primary"
            class="caption font-weight-bold"
            outlined
            rounded
            small
            @click="openEquipmentDialog"
            >{{ $t("hfManagement.showEquipmentBtn") }}</v-btn
          >
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-0">
      <slot name="filters"></slot>
    </v-card-text>
    <v-card-text class="px-0">
      <div v-if="hasMachinery" class="machinery-list-container pr-1">
        <transition-group name="slide-fade" mode="out-in">
          <machinery-list-item
            v-for="machinery in machineryList"
            :key="machinery.machineryId"
            :machinery="machinery"
            @openeditmachinerywithiddialog="openEditMachineryWithIdDialog"
          />
        </transition-group>
      </div>
      <!--<div v-else :key="hasMachinery">
        <h2 class="font-italic font-weight-light">
          {{ $t("hfManagement.machineryPerformance.emptyMachineryListMsg") }}
        </h2>
      </div>-->
    </v-card-text>
    <new-machinery-modal
      :hasWritePerm="hasWritePerm"
      :officeId="officeId"
      :newMachineryDialog="dialogs.newMachinery"
      @closenewmachineryformdialog="dialogs.newMachinery = false"
    />
    <edit-machinery-modal
      :hasWritePerm="hasWritePerm"
      :officeId="officeId"
      :editMachineryDialog="dialogs.editMachinery"
      :selectedMachineryId="selectedMachineryId"
      @closeeditmachineryformdialog="dialogs.editMachinery = false"
    />
    <equipment-modal
      :visible="dialogs.equipment"
      @close="dialogs.equipment = false"
    />
  </div>
</template>

<script>
import HFMachineryListItem from "./HFMachineryListItem";
import HFNewMachineryModal from "./HFNewMachineryModal";
import HFEditMachineryModal from "./HFEditMachineryModal";
import HFEquipmentModal from "./HFEquipmentModal";

export default {
  components: {
    MachineryListItem: HFMachineryListItem,
    NewMachineryModal: HFNewMachineryModal,
    EditMachineryModal: HFEditMachineryModal,
    EquipmentModal: HFEquipmentModal
  },
  data() {
    return {
      officeId: null,
      dialogs: {
        newMachinery: false,
        editMachinery: false,
        equipment: false
      },
      selectedMachineryId: "",
      dataLoaded: {
        officeEquimpent: false,
        serviceList: false
      }
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.officeId = this.$store.getters["hfManagement/officeId"];
      this.$store.commit("machinery/RESET_MACHINERY_FORM");
      this.getOfficeEquipment();
      this.getServiceList();
    },
    async getOfficeEquipment() {
      await this.$store
        .dispatch("machinery/fetchOfficeEquipment", this.officeId)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.dataLoaded.officeEquimpent = true;
        });
    },
    async getServiceList() {
      await this.$store
        .dispatch("machinery/fetchServiceList", this.officeId)
        .then(() => {})
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.dataLoaded.serviceList = true;
        });
    },
    openNewMachineryDialog() {
      this.dialogs.newMachinery = true;
    },
    openEditMachineryWithIdDialog(machineryId) {
      this.selectedMachineryId = machineryId;
      this.dialogs.editMachinery = true;
    },
    openEquipmentDialog() {
      this.dialogs.equipment = true;
    }
  },
  computed: {
    hasReadPerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONESTRUTTURASANITARIA",
        "READ"
      );
    },
    hasWritePerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONESTRUTTURASANITARIA",
        "READWRITE"
      );
    },
    machineryList() {
      return this.$store.getters["machinery/machineryList"];
    },
    serviceList() {
      return this.$store.getters["machinery/servicesList"];
    },
    hasMachinery() {
      let totalMachinery = this.$store.getters["machinery/totalItems"];
      return totalMachinery > 0;
    },
    showPageContent() {
      return this.dataLoaded.officeEquimpent && this.dataLoaded.serviceList;
    }
  }
};
</script>

<style scoped>
.page-content {
  min-height: 70vh;
}

.container-panel {
  background-color: #fff;
}

.machinery-item-wrapper {
  background-color: white !important;
}

.iconav {
  font-size: 22px !important;
  color: #17365d;
}

.machinery-list-container {
  max-height: 400px;
  overflow-y: auto;
}

.machinery-card-item {
  margin-bottom: 8px;
}

.machinery-card-item:last-child {
  margin-bottom: 2px;
}

::-webkit-scrollbar {
  background: #b0bec5;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
  background-color: #17365d;
}
</style>
